import styled from 'styled-components';

export default styled.div`
  &::after {
    content: "";
    clear: both;
    display: table;
  }
`;
